const createData = (name: string, spot: string, revertDate: string) => ({
  name,
  spot,
  revertDate,
});

export const mockupRows = [
  createData('Net disposable income', 'N/A', 'May 7th, 2022'),
  createData('Unstressed payment', 'N/A', 'May 7th, 2022'),
  createData('Stressed payment', 'N/A', 'May 7th, 2022'),
  createData('Stressed residual', 'N/A', 'May 7th, 2022'),
];
